module.exports = __webpack_public_path__ + "img/banner4.99f69401.png";